import validate from "/home/dev/uogorod-src/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45access_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/admin-access.global.ts";
import brand_45redirect_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/brand-redirect.global.ts";
import catalog_45merge_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/catalog-merge.global.ts";
import category_45redirect_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/category-redirect.global.ts";
import google_45tag_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/google-tag.global.ts";
import retired_45plant_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/retired-plant.global.ts";
import retired_45post_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/retired-post.global.ts";
import user_45updated_45at_45global from "/home/dev/uogorod-build-local-fonts-20261103/middleware/user-updated-at.global.ts";
import manifest_45route_45rule from "/home/dev/uogorod-src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45access_45global,
  brand_45redirect_45global,
  catalog_45merge_45global,
  category_45redirect_45global,
  google_45tag_45global,
  retired_45plant_45global,
  retired_45post_45global,
  user_45updated_45at_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}